export default "__VITE_ASSET__CbGcMz7E__"